import { useAuthStore } from "@/stores/authStore";

/**
 * Hook personalizado para autenticación
 *
 * Proporciona un punto centralizado para acceder al estado
 * de autenticación y sus acciones. Esto facilita el uso
 * del store en componentes y mantiene la consistencia.
 */
export const useAuth = useAuthStore;

export default useAuth;
